import PropTypes from "prop-types";
import { Chakra } from "@airhelp/react-ui-components";

const { Box, Text, AspectRatio, Image, Link } = Chakra;

export const ArrowIcon = ` ${String.fromCodePoint("8594")}`;

const PressCoverageItem = ({ href, image, title }) => (
  <Link href={href} isExternal _hover={{ textDecor: "none" }}>
    <AspectRatio ratio={19 / 12} mb={4}>
      <Box border="1px" borderColor="greyscale.400" rounded="xl">
        <Image src={image} title={title} />
      </Box>
    </AspectRatio>
    <Text mb={2} color="primary.900" fontWeight="bold" fontSize="xl" lineHeight="1.2">
      {`${title}${ArrowIcon}`}
    </Text>
  </Link>
);

export default PressCoverageItem;

PressCoverageItem.propTypes = {
  href: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};
